import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLanguage } from "../../../contexts/LanguageContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const ApprovalOrdersTable = ({ data, isLoading, onView }) => {
    const { th } = useLanguage();
    const actionTemplate = (row) => (
        <Button
            icon="pi pi-eye"
            className="p-button-text p-button-rounded p-button-info"
            onClick={() => onView(row)}
            tooltip={th("approvalOrders.details")}
            tooltipOptions={{ position: "top" }}
        />
    );


    const statusIconTemplate = (row) => {
        switch (row.approvalStatus) {
            case 20:
                return (
                    <span className="flex align-items-center gap-2 text-gray-700">
                        <i className="pi pi-clock mr-2"></i> {th("approvalOrders.status.sentForApproval")}
                    </span>
                );
            case 30:
                return (
                    <span className="flex align-items-center gap-2 text-green-600">
                        <i className="pi pi-check-circle mr-2"></i> {th("approvalOrders.status.approved")}
                    </span>
                );
            case 25:
                return (
                    <span className="flex align-items-center gap-2 text-red-500">
                        <i className="pi pi-times-circle mr-2"></i> {th("approvalOrders.status.rejected")}
                    </span>
                );
            default:
                return <span>-</span>;
        }
    };

    return (
        <DataTable
            value={data}
            loading={isLoading}
            paginator
            rows={10}
            showGridlines
            stripedRows
            responsiveLayout="scroll"
            emptyMessage={th("common.noRecords")}
        >
            <Column header={th("common.actions")} body={actionTemplate} style={{ width: "6rem" }} frozen />
            <Column field="id" header={th("approvalOrders.columns.orderId")} sortable />
            <Column field="sasNo" header={th("shipmentDelivery.orderNumber")} sortable />
            <Column field="orderType" header={th("approvalOrders.columns.orderType")} sortable />
            <Column field="dealerName" header={th("approvalOrders.columns.dealerName")} sortable />
            <Column
                field="createdDate"
                header={th("approvalOrders.columns.createdDate")}
                body={(row) =>
                    row.createdDate
                }
                sortable
            />
            <Column
                field="retailAmount"
                header={th("approvalOrders.columns.retailAmount")}
                body={(row) => Number(row.retailAmount ?? 0).toFixed(2)}
                sortable
            />
            <Column
                field="netAmount"
                header={th("approvalOrders.columns.netAmount")}
                body={(row) => Number(row.netAmount ?? 0).toFixed(2)}
                sortable
            />
            <Column
                field="approvalStatus"
                header={th("approvalOrders.columns.status")}
                body={statusIconTemplate}
                style={{ minWidth: "14rem" }}
            />
        </DataTable>
    );
};

export default ApprovalOrdersTable;
